import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMobileMenuOpen } from '../../Actions/Navigation.action';
import Icon from '../Icon';
import SideMenu from '../SideMenu';
import { translate } from '../../Services/translation';
import MobileNavigationItem from './ui/MobileNavigationItem';
import MobileNavigationDropdown from './ui/MobileNavigationDropdown';
import useEcommerceDisabled from '../../Hooks/useEcommerceDisabled';
import LanguageSelect from '../LanguageSelect';

const NavigationMobile = () => {
  const dispatch = useDispatch();
  const ecommerceDisabled = useEcommerceDisabled();
  const {
    mobileMenuOpen,
    logoUrl,
    contentLinks,
    startPageUrl,
    languageSelectEnabled,
  } = useSelector((state) => state.navigation);
  const { contactUsPageUrl } = useSelector((state) => state.site);
  const [currentLink, setCurrentLink] = useState();
  const [previousLink, setPreviousLink] = useState();
  const [languageSelectOpen, setLanguageSelectOpen] = useState(false);

  const links = useMemo(() => currentLink?.links ?? contentLinks, [
    contentLinks,
    currentLink,
  ]);

  const Header = () => (
    <>
      {currentLink || languageSelectOpen ? (
        <>
          <button
            className="navigation-mobile__back-button"
            onClick={onBackClick}
          >
            <Icon
              className="navigation-mobile__back-button-icon"
              name="Caret-Left"
              size={24}
            />
            {translate('general.back')}
          </button>
          <button
            className="navigation-mobile__close-button"
            onClick={() => dispatch(setMobileMenuOpen(false))}
          >
            <Icon
              name="Close"
              className="navigation-mobile__close-button-icon"
              size={24}
            />
          </button>
        </>
      ) : (
        <>
          {logoUrl && (
            <a href={startPageUrl} className="navigation-mobile__logo-wrapper">
              <img
                className="navigation-mobile__logo"
                src={logoUrl}
                alt={translate('megamenu.logo')}
              />
            </a>
          )}
          <button
            className="navigation-mobile__close-button"
            onClick={() => dispatch(setMobileMenuOpen(false))}
            aria-label={translate('megamenu.close')}
          >
            <Icon
              name="Close"
              className="navigation-mobile__close-button-icon"
              size={24}
            />
          </button>
        </>
      )}
    </>
  );

  const Content = () => (
    <>
      {languageSelectOpen ? (
        <LanguageSelect />
      ) : (
        <ul className="navigaton-mobile__list">
          {!currentLink && !ecommerceDisabled && <MobileNavigationDropdown />}
          {currentLink?.url && (
            <MobileNavigationItem
              url={currentLink?.url}
              name={`${translate('megamenu.see-all')} ${currentLink.name}`}
            />
          )}
          {links.map((link) => (
            <MobileNavigationItem
              link={link}
              name={link.name}
              url={link.url}
              key={'mobile' + link.url + link.name}
              onLinkClick={onLinkClick}
              className={!currentLink && 'navigation-mobile__list-item--bold'}
              icon={link.mobileIconName}
            />
          ))}
          {contactUsPageUrl && (
            <a
              href={contactUsPageUrl}
              className="navigation-mobile__list-item navigation-mobile__list-item--bold navigation-mobile__link"
            >
              <Icon
                name="Headset"
                size={24}
                className="navigation-mobile__link-icon"
              />
              {translate('general.contact')}
            </a>
          )}
          {!currentLink && languageSelectEnabled && (
            <button
              className="navigation-mobile__list-item navigation-mobile__list-item--bold navigation-mobile__link"
              onClick={() => setLanguageSelectOpen(true)}
            >
              <Icon
                name="Globe"
                size={24}
                className="navigation-mobile__link-icon"
              />
              {translate('general.language')}
            </button>
          )}
        </ul>
      )}
    </>
  );

  const onLinkClick = (link) => {
    link.previousLink = previousLink ?? currentLink;
    setPreviousLink(currentLink);
    setCurrentLink(link);
  };

  const onBackClick = () => {
    if (languageSelectOpen) {
      setLanguageSelectOpen(false);
    } else {
      setPreviousLink(previousLink?.previousLink);
      setCurrentLink(previousLink);
    }
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      setCurrentLink(null);
    }
  }, [mobileMenuOpen]);

  return (
    <SideMenu
      from="left"
      id="navigation-mobile"
      className="navigation-mobile__side-menu"
      zIndex={60}
      open={mobileMenuOpen}
      onClosed={() => {
        dispatch(setMobileMenuOpen(false));
        setLanguageSelectOpen(false);
      }}
      components={{ Header, Content }}
      showCloseButton={false}
    />
  );
};
export default NavigationMobile;
